<div class="chat_sidebar" [ngClass]="{ active: openChat }">
  <div class="row g-0 sidebar_body">
    <div class="col-12 chat_head">
      <button type="button" class="btn close_chat" (click)="toggleChat(openChat)"><i class="material-icons" aria-hidden="true">close</i></button>
      <button type="button" class="btn reset_chat" (click)="initChatSession(botSession.currentSettings)"><i class="fas fa-redo" aria-hidden="true"></i></button>
      <button type="button" class="btn settings_chat" (click)="editCustomData()"><i class="fas fa-cog" aria-hidden="true"></i></button>
    </div>

    @if (botSession) {
      <div class="col-12 chat_modules">
        <ng-template [spinnerLoader]="subscriptions['ChatSubscription']?.closed"></ng-template>
        <section class="dialog_module" id="chatWrapper">
          <div #chatDialog class="module_body" [scrollTop]="chatDialog.scrollHeight">
            @for (interaction of botSession.dialog; track interaction; let interactionIndex = $index; let lastInteraction = $last) {
              <section class="speech_row">
                @for (message of interaction.messages; track message; let messageIndex = $index; let lastMessage = $last) {
                  <article class="speech_message" [ngClass]="{ bot_message: interaction.type === 'bot', user_message: interaction.type === 'user', graphics_message: message.payload }">
                    @if (message.text) {
                      <span class="speech_text" [innerHTML]="message.text"></span>
                    }
                    <section class="speech_graphics type_{{ message.type }}">
                      @switch (message.type) {
                        @case ('suggestions') {
                          <owl-carousel-o [options]="chipsCarouselOptions" (dragging)="onDragging($event)">
                            @for (item of message.items; track item) {
                              <ng-template carouselSlide>
                                <button class="btn graphics_suggestion" (click)="!dragging && selectGraphicElement('value', item, message)">{{ item.title }}</button>
                              </ng-template>
                            }
                          </owl-carousel-o>
                        }
                        @case ('audio') {
                          @for (item of message.items; track item) {
                            <span class="speech_audio">
                              {{ item.query }}
                              <audio [src]="item.source | urlSanitizer" controls controlsList="nodownload"></audio>
                            </span>
                          }
                        }
                        @case ('card') {
                          <owl-carousel-o [options]="cardCarouselOptions">
                            @for (item of message.items; track item) {
                              <ng-template carouselSlide [width]="225">
                                <article class="graphics_card">
                                  @if (item.image) {
                                    <figure class="card_image">
                                      <img [src]="item.image" alt="{{ item.alt_image }}" />
                                    </figure>
                                  }
                                  <div class="card_body">
                                    <h5 class="body_title">{{ item.title }}</h5>
                                    @if (item.subtitle) {
                                      <h6 class="body_subtitle">{{ item.subtitle }}</h6>
                                    }
                                    @if (item.body) {
                                      <p class="body_text">{{ item.body | slice: 0:75 }}@if (item.body.length > 75) {
                                        <span>...</span>
                                      }</p>
                                    }
                                  </div>
                                  @if (message.buttonType !== 'disabled') {
                                    <footer class="card_bottom">
                                      <button type="button" class="btn brand_default" (click)="selectGraphicElement(message.buttonType, item.button, message)">{{ item.button.value_name }}</button>
                                    </footer>
                                  }
                                </article>
                              </ng-template>
                            }
                          </owl-carousel-o>
                        }
                      }
                    </section>
                  </article>
                }
                @if (interaction.detectedInteraction) {
                  <small class="text-secondary">{{ interaction.detectedInteraction }}</small>
                  <a href="javascript:void(0)" class="debug_info" (click)="viewDebug(interaction)" aria-label="Visualizza informazioni di debug"><i class="fa-solid fa-info-circle fa-sm" aria-hidden="true"></i></a
                  >
                }
              </section>
            }
          </div>
          <footer class="module_bottom">
            <button [ngbPopover]="popEvent" popoverClass="event_pop" [autoClose]="'outside'" triggers="manual" #p="ngbPopover" (click)="p.open()" container="body" type="button" class="btn record_audio">
              <i class="fa-solid fa-arrow-up-from-bracket" aria-hidden="true"></i>
            </button>
            <ng-template #popEvent>
              <h6 class="text-center">Invoke Event</h6>
              <form (ngSubmit)="eventForm.valid && submitEvent(); eventForm.valid && p.close()" #eventForm="ngForm" autocomplete="off" class="chat_form">
                <div class="event_field">
                  <input name="eventInput" type="text" placeholder="Event..." class="form-control" [(ngModel)]="botSession.inputEvent" #eventInput="ngModel" required />
                  <button type="submit" class="btn send_button">
                    <span class="material-icons">send</span>
                  </button>
                </div>
              </form>
            </ng-template>
            <form #chatForm="ngForm" class="chat_form" (ngSubmit)="submitText()" autocomplete="off" novalidate>
              <fieldset [disabled]="disableChat">
                <legend class="d-none"></legend>
                <div class="speech_field">
                  <input name="speechInput" maxlength="255" type="text" placeholder="Enter text..." class="form-control" [(ngModel)]="botSession.inputMessage" #speechInput="ngModel" />
                  @if (botSession.inputMessage.length === 0) {
                    <button type="button" class="btn record_audio" (click)="speechRecording()" [ngClass]="{ on_recording: botSession.recorderState === 'recording' }">
                      <i class="fas fa-microphone" aria-hidden="true"></i>
                    </button>
                  }
                  @if (botSession.inputMessage.length > 0) {
                    <button class="send_message" type="submit">
                      <span class="material-icons">send</span>
                    </button>
                  }
                </div>
              </fieldset>
            </form>
          </footer>
        </section>
      </div>
    }
  </div>
</div>
